<template>
  <div class="translation">
    <Logo />
    <div class="title_and_phone1">
      <h1>{{ $t("companyName") }}</h1>
      <a class="phone_number" :href="`tel:${$t('phone_number')}`">{{ $t("phone_number") }}</a>
    </div>
    <ApplyForLoan class="apply" />
    <Search />
    <language-translators />
  </div>
</template>
<script>
import LanguageTranslators from './LanguageTranslators.vue';
import Logo from './Logo.vue';
import Search from './SearchInput.vue';
import ApplyForLoan from './ApplyForLoan.vue';

export default {
  components: {
    LanguageTranslators,
    Logo,
    Search,
    ApplyForLoan,
  },
};
</script>

<style lang="scss">
.apply {
  margin-left: auto;
  margin-right: 20px;
}
.translation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 20px 50px !important;
  margin: 15px 15px 0px 15px;
  background-color: white;
  border-radius: 4px 4px 0px 0px;
  border-width: 0px 1px 0px 1px;
  border-style: solid;
  border-color: #e8eaec;
  &:before {
    background-color: #10a995;
    padding: 13px;
    width: calc(100% - 20px);
    position: absolute;
    z-index: 1;
    content: "";
    /* margin: inherit; */
    bottom: 6px;
    left: 10px;
    border-radius: 4px;
  }
  .links {
    margin-bottom: unset;
  }
  .title_and_phone1 {
    display: flex;
    flex-direction: column;
    margin-left: 10px;
    margin-bottom: 5px;
    height: 100%;
    h1 {
      line-height: 1;
      color: #10a995;
      font-size: 2.6em;
    }
    .phone_number {
      margin-left: 5px;
    }
  }

  .ivu-input-wrapper {
    flex: 0 0 400px;
    top: unset;
    margin-right: 20px;
  }
}

@media only screen and (max-width: 1200px) {
  .translation {
    display: none;
  }
}
@media only screen and (max-width: 1200px) {
  .phone_number {
    display: none;
  }
}
</style>
